function formatIt(date: Date, form: string) {
    const pad = (n: number) => (n < 10 ? `0${n}` : n)
    const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
    )}`
    const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`
    if (form === 'YYYY-MM-DD') {
        return dateStr
    }
    if (form === 'HH:mm') {
        return timeStr
    }
    return `${dateStr} ${timeStr}`
}

export function formatFn(instance: any, value: Date) {
    const formatsEnum = {
        date: 'YYYY-MM-DD',
        time: 'HH:mm',
        datetime: 'YYYY-MM-DD HH:mm',
    }
    const { format } = instance.props
    const type = typeof format
    if (type === 'string') {
        return formatIt(value, format)
    }
    if (type === 'function') {
        return format(value)
    }
    return formatIt(value, (formatsEnum as any)[instance.props.mode])
}

export function getComponentLocale(
    props: any,
    context: any,
    componentName: string,
    getDefaultLocale: () => any
) {
    let locale: any = {}
    if (context && context.antLocale && context.antLocale[componentName]) {
        locale = context.antLocale[componentName]
    } else {
        const defaultLocale = getDefaultLocale()
        // TODO: make default lang of antd be English
        // https://github.com/ant-design/ant-design/issues/6334
        locale = defaultLocale.default || defaultLocale
    }

    let result = {
        ...locale,
    }
    if (props.locale) {
        result = {
            ...result,
            ...props.locale,
        }
        if (props.locale.lang) {
            result.lang = {
                ...locale.lang,
                ...props.locale.lang,
            }
        }
    }
    return result
}

export function getLocaleCode(context: any) {
    const localeCode = context.antLocale && context.antLocale.locale
    // Had use LocaleProvide but didn't set locale
    if (context.antLocale && context.antLocale.exist && !localeCode) {
        return 'zh-cn'
    }
    return localeCode
}
